import React, {useCallback, useState} from "react";
import "./index.scss";
import {bool, func, object, oneOfType, string} from "prop-types";
import Text from "features/components/text";

export const Switch = (props) => {
    const {title, disabled = false, status, onChange} = props;
    const [statusVal, setStatus] = useState(status);
    const toggleStatus = useCallback(() => {
        setStatus(!statusVal);
        onChange(!statusVal);
    }, [onChange, statusVal]);
    return <div className={`switch ${disabled ? "disabled" : ""}`}>
        <Text size={16}>{title}</Text>
        <div className={`switch-input ${statusVal ? "active" : ""}`} onClick={toggleStatus}>
            <span className="circle" />
        </div>
    </div>
};
Switch.propTypes = {
    title: oneOfType([string, object]).isRequired,
    status: bool.isRequired,
    disabled: bool,
    onChange: func.isRequired
}